import React, { useEffect, useRef } from "react";
import "./DatatablePopover.scss";
import { DatatablePopoverProps } from "./types";

const DatatablePopover = <T,>({
  rowData,
  availableActions,
  closePopover,
}: DatatablePopoverProps<T>) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("mousedown", onClickEvent);
    return () => document.removeEventListener("mousedown", onClickEvent);
  }, []);

  const onClickEvent = (event: MouseEvent) => {
    if (
      popoverRef &&
      !popoverRef.current?.contains(event.target as HTMLDivElement)
    ) {
      closePopover();
    }
  };

  return (
    <div
      className="datatablePopover"
      ref={popoverRef}
    >
      {availableActions?.length ? (
        availableActions.map((action) => {
          const onClick = () => {
            action.onClick(rowData);
            closePopover();
          };

          return (
            <div
              className="datatablePopover__menuitem"
              key={action.title}
              onClick={onClick}
            >
              {action.title}
            </div>
          );
        })
      ) : (
        <div className="datatablePopover__noActions">No Available Actions</div>
      )}
    </div>
  );
};

export default DatatablePopover;
